<div [style.height.px]="height" class="menu-container">
  <abc-button
    class="control-button"
    [disabled]="
      editorContent.length === 0 ||
      (editorContent === editorInitialValue &&
        (!columnTitle.currentValue.length || columnTitle.currentValue === columnTitle.initialValue))
    "
    (click)="onSaveCloseClick()"
    [stylingMode]="'text'"
    type="normal"
    icon="save"
    [toolTipContent]="translation.menu.saveAndClose"
  >
  </abc-button>
  <abc-button
    class="control-button"
    (click)="onResetClick()"
    [disabled]="!undoHistory?.length && !redoHistory?.length"
    [stylingMode]="'text'"
    type="normal"
    icon="refresh"
    [toolTipContent]="translation.menu.reset"
  >
  </abc-button>
  <abc-button
    class="control-button"
    (click)="onUndoClick()"
    [disabled]="!undoHistory?.length"
    [stylingMode]="'text'"
    type="normal"
    icon="undo"
    [toolTipContent]="translation.menu.undo"
    #undoButton
  >
  </abc-button>
  <abc-button
    class="control-button"
    (click)="onRedoClick()"
    [disabled]="!redoHistory?.length"
    [stylingMode]="'text'"
    type="normal"
    icon="redo"
    [toolTipContent]="translation.menu.redo"
    #redoButton
  >
  </abc-button>
  <abc-button
    class="control-button"
    (click)="onValidateClick()"
    [disabled]="editorContent.length == 0"
    [stylingMode]="'text'"
    type="normal"
    icon="selectall"
    [toolTipContent]="translation.menu.validate"
  >
  </abc-button>
  <abc-button
    class="control-button"
    (click)="onToggleNeutralDesignationClick()"
    [ngClass]="{ active: neutralDesignationActive }"
    [stylingMode]="'text'"
    type="normal"
    icon="fontsize"
    [toolTipContent]="translation.menu.neutralDesignation"
  >
  </abc-button>
</div>
